import { render, staticRenderFns } from "./historianTemp.vue?vue&type=template&id=dc95bb7e&scoped=true&"
import script from "./historianTemp.vue?vue&type=script&lang=ts&"
export * from "./historianTemp.vue?vue&type=script&lang=ts&"
import style0 from "./historianTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./historianTemp.vue?vue&type=style&index=1&id=dc95bb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95bb7e",
  null
  
)

export default component.exports